import { useContext, useEffect, useState } from "react";
import styles from "./styles/NotaryCard.module.css";
import lawyer_image from "./styles/img/lawyer_image.svg";
import lawyer_icon from "./styles/img/laywer_icon.svg";
import PhoneInput from "react-phone-input-2";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { formatUrl } from "../../Utils/formatUrl";
import NotaryBenefPopup from "./BenefNotaryPopup";
export default function BenefNotaryCard({ notary, setModal }) {
  const {
    additional_information,
    name,
    email,
    phone_number,
    address,
    profile_avatar,
    website_url,
  } = notary;

  const websiteCurrentLang = useContext(LanguageContext).language;
  const [previewedLogo, setPreviewedLogo] = useState(undefined);
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    if (
      profile_avatar &&
      profile_avatar !== null &&
      profile_avatar !== undefined
    ) {
      let extension = profile_avatar[0];
      if (extension === "/") extension = ".jpg";
      else if (extension === "i") extension = ".png";

      const imageUrl = `data:image/${extension};base64,${profile_avatar}`;
      setPreviewedLogo(imageUrl);
    }
  }, [profile_avatar]);
  return (
    <div className={styles.lawyerContainer}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            width: "70%",
          }}
        >
          <p
            className={styles.promotionContainerName}
            style={{
              width: "100%",
            }}
          >
            {name}
          </p>
        </div>
        <div
          style={{
            borderRadius: "50%",
            alignSelf: "flex-start",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          <img
            src={previewedLogo ? previewedLogo : lawyer_image}
            alt="lawyer"
            style={
              previewedLogo
                ? {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                  }
                : {
                    width: "50px",
                    height: "45px",
                    borderRadius: "50%",
                  }
            }
          />{" "}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          className={styles.promotionContainerItem}
          style={{
            fontWeight: "400",
            width: "80%",
          }}
        >
          <img
            style={{
              scale: "1.2",
            }}
            src={lawyer_icon}
            alt="icon"
          />
          <p>{email}</p>
        </div>
        <div
          className={styles.promotionContainerItem}
          style={{
            fontWeight: "400",
          }}
        >
          <img
            style={{
              scale: "1.2",
            }}
            src={lawyer_icon}
            alt="icon"
          />
          <PhoneInput
            inputClass={styles.legalPhoneInput}
            buttonClass={styles.legalHide}
            disableSearchIcon={true}
            value={phone_number}
          />
        </div>
        {address?.trim()?.length > 0 && (
          <div
            className={styles.promotionContainerItem}
            style={{
              fontWeight: "400",
            }}
          >
            <img
              style={{
                scale: "1.2",
              }}
              src={lawyer_icon}
              alt="icon"
            />
            <p>{address}</p>
          </div>
        )}{" "}
        {website_url?.length > 0 && (
          <div
            className={styles.promotionContainerItem}
            style={{
              fontWeight: "400",
            }}
          >
            <img
              style={{
                scale: "1.2",
              }}
              src={lawyer_icon}
              alt="icon"
            />
            <a
              rel="noreferrer"
              style={{
                cursor: "pointer",
                color: "var(--color_blue)",
                textDecoration: "underline",
              }}
              href={formatUrl(website_url ? website_url : "#")}
              target="_blank"
              className={styles.promotionContainerTitle}
            >
              {website_url ? website_url : ""}
            </a>
          </div>
        )}
        {additional_information.length > 0 && (
          <div
            className={styles.promotionContainerItem}
            style={{
              fontWeight: "400",
            }}
          >
            <img
              style={{
                scale: "1.2",
              }}
              src={lawyer_icon}
              alt="icon"
            />
            <p
              style={{
                WebkitLineClamp: 2,
              }}
              onClick={() => {}}
            >
              {additional_information}
            </p>
          </div>
        )}
        <div
          className={styles.seeMoreContainer}
          onClick={() => {
            setModal(
              <NotaryBenefPopup
                onClose={() => setModal(undefined)}
                toEdit={notary}
              />
            );
          }}
        >
          <p>{dublicatedcontent.seeMore}</p>
        </div>
      </div>
    </div>
  );
}
